import { getFieldTypes } from "../template/TemplateHelper"
import { AddressAutofill } from "@mapbox/search-js-react"
import { formatDate } from "../../utils/Utilities"
import { getAccountTypes } from "../template/TemplateHelper"


const InputField = ({ infoField, broker, handleInputChange, clientOrAccountsHeaderValue, clientOptions, accountPlatform, fieldOptions }) => {

    const getAccountPlatformOptions = () => {
        let accountTypes = getAccountTypes(broker)
        return Object.keys(accountTypes).map(key => ({"label": key, "value": key}))
    }
    
    const getAccountTypeOptions = () => {
        let accountTypes = getAccountTypes(broker)
        return accountTypes[accountPlatform]?.map(key => ({"label": key, "value": key}))
    }

    const getFieldOptions = (fieldName) => {
        return fieldOptions.filter(fieldOption => fieldOption?.fieldName?.toLowerCase() == fieldName).map(fieldOption => fieldOption.options)[0]
    }

    const createField = () => {
        let fieldName = infoField.formFieldName 
        let lowerCaseFieldName = fieldName?.toLowerCase()
        let value = infoField.formFieldValue || ""
        let fieldTypes = getFieldTypes(broker)
        let type = fieldTypes[lowerCaseFieldName] ? fieldTypes[lowerCaseFieldName].type : "input"
        let required = fieldTypes[lowerCaseFieldName]?.required
        let options = getFieldOptions(lowerCaseFieldName)
        if(fieldName === "Account Platform") {
            options = getAccountPlatformOptions()
        } else if(fieldName === "Account Type" && accountPlatform) {
            options = getAccountTypeOptions()
        }
    
        let field
        if(type === "select") { 
            field =
                <div className="form-group">
                    <label for={fieldName}>{fieldName}</label>
                    <select className={"inpt" + (!value && required ? " required" : "")} 
                        id={fieldName} name={fieldName} 
                        required={required}
                        autoComplete={fieldTypes[lowerCaseFieldName]?.autoComplete} 
                        value={value}
                        style={fieldTypes[lowerCaseFieldName]?.width ? {width: fieldTypes[lowerCaseFieldName]?.width} : {width: "250px"}}
                        onChange={(e) => handleInputChange(clientOrAccountsHeaderValue, fieldName, e.target.value, type)}>
                            <option disabled selected value=""> -- select an option -- </option>
                            {options?.map(option => <option value={option.value}>{option.label}</option>)}
                    </select>
                </div>
        } else if(type === "address") {
            field = 
                <div className="form-group">
                    <label for={fieldName}>{fieldName}</label>
                    <AddressAutofill accessToken={process.env.REACT_APP_MAP_BOX_TOKEN}>
                        <input className={"inpt" + (!value && required ? " required" : "")} 
                            id={fieldName} name={fieldName} 
                            required={required}
                            autoComplete={fieldTypes[lowerCaseFieldName]?.autoComplete} 
                            value={value}
                            style={fieldTypes[lowerCaseFieldName]?.width ? {width: fieldTypes[lowerCaseFieldName]?.width} : {width: "250px"}}
                            onChange={(e) => handleInputChange(clientOrAccountsHeaderValue, fieldName, e.target.value, type)}  
                        />
                    </AddressAutofill>
                </div> 
        } else if(type === "date") {
            let validDateValue = formatDate(value)
            field =
                <div className="form-group">
                    <label for={fieldName}>{fieldName}</label>
                    <input className={"inpt" + (!value && required ? " required" : "")} 
                        id={fieldName} name={fieldName}
                        type='date'
                        required={required}
                        value={value}
                        style={fieldTypes[lowerCaseFieldName]?.width ? {width: fieldTypes[lowerCaseFieldName]?.width} : {width: "250px"}}
                        onChange={(e) => handleInputChange(clientOrAccountsHeaderValue, fieldName, e.target.value, type)}  
                    />
                </div>
        } else if(type === "clientSelect") {
            field = 
                <div className="form-group">
                    <label for={fieldName}>{fieldName}</label>
                    <select className={"inpt" + (!value && required ? " required" : "")} 
                        id={fieldName} name={fieldName} 
                        required={required}
                        autoComplete={fieldTypes[lowerCaseFieldName]?.autoComplete} 
                        value={value}
                        style={fieldTypes[lowerCaseFieldName]?.width ? {width: fieldTypes[lowerCaseFieldName]?.width} : {width: "250px"}}
                        onChange={(e) => handleInputChange(clientOrAccountsHeaderValue, fieldName, e.target.value, type)}>
                            <option disabled selected value=""> -- select an option -- </option>
                            {clientOptions.map(option => <option value={option.name}>{option.name}</option>)}
                    </select>
                </div>
        } else {
            field =
                <div className="form-group">
                    <label for={fieldName}>{fieldName}</label>
                    <input className={"inpt" + (!value && required ? " required" : "")} 
                        id={fieldName} name={fieldName} 
                        required={required}
                        maxLength={fieldTypes[lowerCaseFieldName]?.maximumLength}
                        autoComplete={fieldTypes[lowerCaseFieldName]?.autoComplete} 
                        value={value}
                        style={fieldTypes[lowerCaseFieldName]?.width ? {width: fieldTypes[lowerCaseFieldName]?.width} : {width: "250px"}}
                        onChange={(e) => handleInputChange(clientOrAccountsHeaderValue, fieldName, e.target.value, type)}  
                    />
                </div>
        }
        return field
    }

    return createField()
}

export default InputField